import React, { useState } from 'react';
import SmoothCollapse from 'react-smooth-collapse';
import Button from 'components/common/button/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown } from '@fortawesome/pro-solid-svg-icons/faAngleDown';
import { Props } from './CollapsibleList.interface';
import {
  collapsibleList__button,
  collapsibleList__title,
  collapsibleList__icon,
  collapsibleList__open,
  collapsibleList__closed,
  collapsibleList__text,
} from './CollapsibleList.scss';

export default ({ index, onClick, activeIndex, openText, closeText, ariaLabel, children }: Props): JSX.Element => {
  const buttonText = activeIndex === index ? closeText || 'Open' : openText || 'Close';
  const listState = activeIndex === index ? collapsibleList__open : collapsibleList__closed;

  return (
    <>
      <Button
        role="primary"
        className={`${collapsibleList__button} ${listState}`}
        onClick={onClick}
        aria-label={ariaLabel}
      >
        <span className={collapsibleList__title}>
          <h4>{buttonText}</h4>
        </span>
        <span className={collapsibleList__icon}>
          <FontAwesomeIcon icon={faAngleDown} />
        </span>
      </Button>
      <SmoothCollapse expanded={activeIndex === index}>
        <div className={collapsibleList__text}>{children}</div>
      </SmoothCollapse>
    </>
  );
};
